import React, {Component} from 'react';
import Content from "./Content/Content";

export default class Main extends Component {
    render() {
        return (
            <div>
                <Content/>
            </div>
        )
    };
}


// WEBPACK FOOTER //
// ./src/components/Main.js